import { render, staticRenderFns } from "./ClassicCaseDetail.vue?vue&type=template&id=0507f878&scoped=true&"
import script from "./ClassicCaseDetail.vue?vue&type=script&lang=js&"
export * from "./ClassicCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClassicCaseDetail.vue?vue&type=style&index=0&id=0507f878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0507f878",
  null
  
)

export default component.exports